import React from 'react'
import { Container, Label } from './styles'

const CheckboxComponent = ({
  name = null,
  checked = false,
  onClick = null,
  onChange = null,
  label,
}) => {
  return (
    <Container onClick={onChange ? () => onChange(name, !checked) : onClick}>
      <i className="material-icons">
        {checked ? 'check_box' : 'check_box_outline_blank'}
      </i>
      <Label>{label}</Label>
    </Container>
  )
}

export default CheckboxComponent
